import React, { useCallback } from 'react';
import { useLocation, useNavigate, useOutletContext, useSearchParams } from 'react-router-dom';
import ProcesosPeriodoInstanciaModal, {
  type ProfasePeriodoActividadInstanciaRow,
  parseInstanciaEstadoVista,
  type InstanciaEstadoVista,
} from './ProcesosPeriodoInstanciaModal';
import { applyPeriodoFilterToParams } from './procesos-periodo-utils';
import {
  setInstanciaEstadoVistaFilter,
  setTipoPeriodoFilter,
} from '../../shared/periodo-actividad-instancia-filters';
import type { ProcesosOutletContext } from './procesos-periodo-page';

interface ProcesosPeriodoInstanciaLocationState {
  procesosSearch?: string;
}

function readProcesosReturnSearch(location: ReturnType<typeof useLocation>): string {
  return (location.state as ProcesosPeriodoInstanciaLocationState | null)?.procesosSearch ?? '';
}

export default function ProcesosPeriodoActividadInstanciaModalRoute() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { refreshAfterPeriodoChange } = useOutletContext<ProcesosOutletContext>();

  const estadoVista = parseInstanciaEstadoVista(searchParams.get('estado'));
  const tipoPeriodo = searchParams.get('tipoPeriodo');
  const procesosReturnSearch = readProcesosReturnSearch(location);

  const handleClose = useCallback(() => {
    navigate(`/procesos${procesosReturnSearch}`);
  }, [navigate, procesosReturnSearch]);

  const handleEstadoVistaChange = useCallback((vista: InstanciaEstadoVista) => {
    setSearchParams(setInstanciaEstadoVistaFilter(searchParams, vista), { replace: true });
  }, [searchParams, setSearchParams]);

  const handleTipoPeriodoFilter = useCallback((value: string) => {
    setSearchParams(setTipoPeriodoFilter(searchParams, value), { replace: true });
  }, [searchParams, setSearchParams]);

  const handleSelectInstancia = useCallback((instancia: ProfasePeriodoActividadInstanciaRow) => {
    const periodo = instancia.periodo;
    if (!periodo?.id) return;

    const params = new URLSearchParams(
      procesosReturnSearch.startsWith('?')
        ? procesosReturnSearch.slice(1)
        : procesosReturnSearch,
    );
    if (!applyPeriodoFilterToParams(params, periodo)) return;
    navigate(`/procesos?${params.toString()}`);
  }, [navigate, procesosReturnSearch]);

  return (
    <ProcesosPeriodoInstanciaModal
      open
      estadoVista={estadoVista}
      tipoPeriodo={tipoPeriodo}
      listSearch={location.search}
      onEstadoVistaChange={handleEstadoVistaChange}
      onTipoPeriodoFilter={handleTipoPeriodoFilter}
      onClose={handleClose}
      onSelectInstancia={handleSelectInstancia}
      onArchivadoChange={refreshAfterPeriodoChange}
    />
  );
}
